import React from 'react';
import { Input, Button, Select, Textarea, Table } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { connect } from 'react-redux';
import { ReportService } from 'services';
import moment from 'moment';

interface Props extends RootState {
	onClose?: any;
	item?: any;
}

class ModalView extends React.Component<Props> {

	state = {
		item: null
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await ReportService.admin.appointments.view({
			appointment_id: this.props.item?.id
		});
		this.setState({
			item: res.appointment
		});
	}
	
	render() {
		const item: any = this.state.item;

		return (
			<div id="modal-view-sale">
				<div className="row">
					{
						this.props.user?.level_id != Constants.LEVELS.CLIENT && (
							<div className="col-md-4">
								<p className="bold">Usuario:</p>
								<p className="value">{ item?.user != null ? (item?.user?.name + ' ' + item?.user?.lastname) : '-' }</p>
							</div>
						)
					}
					<div className="col-md-4">
						<p className="bold">Cliente:</p>
						<p className="value">{ item?.name || '-' }</p>
					</div>
					<div className="col-md-4">
						<p className="bold">Teléfono:</p>
						<p className="value">{ item?.phone || '-' }</p>
					</div>
					<div className="col-md-4">
						<p className="bold">Documento de Identidad:</p>
						<p className="value">{ item?.document || '-' }</p>
					</div>
					<div className="col-md-4">
						<p className="bold">Fecha y Hora:</p>
						<p className="value">{ moment(item?.date).format('DD/MM/YYYY HH:mm') }</p>
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ModalView);